import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib/core/store';
import { createSlice } from '@reduxjs/toolkit';

export const sitesUiSlice = createSlice({
  name: 'sites-ui',
  initialState: {
    ...baseUiInitialState,
  },
  reducers: {
    ...baseUiReducers,
  },
});
